import React, { Component } from "react";
import _ from "lodash";
import Fuse from "fuse.js";
import { connect } from "react-redux";
import { Query } from "react-apollo";
import { selectShipment, deselectShipment } from "../../actions/select_actions";
import { allShipments } from "../../queries/shipments";
import { Box } from "reflexbox";
import ArchiveSwitch from "../../common/Buttons/_ArchiveSwitch";

import {
  DetailsList,
  Selection,
  ConstrainMode
} from "office-ui-fabric-react/lib/DetailsList";
import ShipmentTableCommandBar from "./_ShipmentTableCommandBar";
import { _columns } from "./_ShipmentTableColumns";
import {
  DatePicker,
  DayOfWeek,
} from "office-ui-fabric-react/lib/DatePicker";
import { Checkbox } from "office-ui-fabric-react/lib/Checkbox";
import { Label } from "office-ui-fabric-react/lib/Label";

const fuseConfig = {
  caseSensitive: false,
  tokenize: true,
  shouldSort: true,
  threshold: 0.0,
  keys: [
    "date",
    "cargoTypeByCargoTypeId.type",
    "carrierByCarrierId.truck",
    "carrierByCarrierId.trailer",
    "relationByRelationId.name"
  ]
};

class Shipments extends Component {
  constructor(props) {
    super();

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({ selectedItems: this._selection.getSelection() });
      }
    });

    this.state = {
      prevProps: [],
      items: [],
      selectedItems: [],
      columns: _columns
    };
  }

  static getDerivedStateFromProps(props, state) {
    const prevProps = state.prevProps;
    
    if (prevProps.items !== props.items) {
      return { items: props.items, prevProps: props };
    } else return null;
  }

  _handleSearch = text => {
    const fuse = new Fuse(this.state.items, fuseConfig);
    this.setState({ items: text ? fuse.search(text) : this.props.items });
  };

  _onColumnClick = (event, column) => {
    let { items, columns } = this.state;
    let isSortedDescending = column.isSortedDescending;
    if (column.isSorted) {
      isSortedDescending = !isSortedDescending;
    }
    if (isSortedDescending) {
      items = _.sortBy(items, column.fieldName);
    } else {
      items = _.reverse(_.sortBy(items, column.fieldName));
    }
    this.setState({
      items: items,
      columns: columns.map(col => {
        col.isSorted = col.key === column.key;
        if (col.isSorted) {
          col.isSortedDescending = isSortedDescending;
        }
        return col;
      })
    });
  };

  render() {
    return (
      <div style={{ width: "100vw" }}>
        <Box flex align="center">
          <ShipmentTableCommandBar
            items={this.state.items}
            selectedItems={this.state.selectedItems}
            handleSearch={this._handleSearch}
          />
          <Box ml={1}>
            <ArchiveSwitch />
          </Box>
          <Box ml={2} flex align="center">
            <Label>From : </Label>
            <DatePicker
              value={new Date(this.props.loadingDateAfter)}
              allowTextInput={false}
              isRequired={false}
              onSelectDate={this.props.setLoadingDateAfter}
              firstDayOfWeek={DayOfWeek.Monday}
            />
          </Box>
          <Box ml={1} flex align="center">
            <Label>Till :</Label>
            <DatePicker
              value={new Date(this.props.loadingDateBefore)}
              allowTextInput={false}
              isRequired={false}
              onSelectDate={this.props.setLoadingDateBefore}
              firstDayOfWeek={DayOfWeek.Monday}
            />
          </Box>
        </Box>
        <Box>
          <div className="list-container" data-is-scrollable="true">
            <DetailsList
              className="list-body"
              items={this.state.items}
              setKey="key"
              columns={this.state.columns}
              listProps={{ usePageCache: true }}
              compact
              constrainMode={ConstrainMode.horizontalConstrained}
              layoutMode={ConstrainMode.fixedColumns}
              selectionPreservedOnEmptyClick={true}
              selection={this._selection}
              onColumnHeaderClick={this._onColumnClick}
              onActiveItemChanged={(item, index) =>
                this.props.selectShipment(item)
              }
            />
          </div>
        </Box>
      </div>
    );
  }
}

class ShipmentsTable extends Component {
  state = {
    loadingDateAfter: new Date(Date.now() - 86400000),
    loadingDateBefore: new Date()
  };


  setLoadingDateAfter = date => {
    this.setState({ loadingDateAfter: date });
  };

  setLoadingDateBefore = date => {
    this.setState({ loadingDateBefore: date });
  };

  render() {
    const { selectShipment, deselectShipment } = this.props;

    return (
      <Query
        query={allShipments}
        variables={{
          archived: this.props.isArchiveVisible,
          loadingDateAfter: this.state.loadingDateAfter,
          loadingDateBefore: this.state.loadingDateBefore

        }}
        // pollInterval={25000}
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>;
          if (error) return <p>Error :(</p>;

          const items = _.orderBy(data.allShipments.nodes, ["date"], ["desc"]);

          return (
            <Shipments
              items={items}
              loadingDateAfter={this.state.loadingDateAfter}
              loadingDateBefore={this.state.loadingDateBefore}
              setLoadingDateAfter={this.setLoadingDateAfter}
              setLoadingDateBefore={this.setLoadingDateBefore}
              selectShipment={selectShipment}
              deselectShipment={deselectShipment}
            />
          );
        }}
      </Query>
    );
  }
}

const mapStateToProps = state => {
  return {
    isArchiveVisible: state.ui.isArchivedShipmentsVisible
  };
};

export default connect(mapStateToProps, {
  selectShipment: selectShipment,
  deselectShipment: deselectShipment
})(ShipmentsTable);



// WEBPACK FOOTER //
// ./src/views/Shipments/_ShipmentTable.js